module.exports = __webpack_public_path__ + "static/img/p3-1.82ffb64.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p3-1.jpg
// module id = +nda
// module chunks = 1